import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

const MESSAGES = [
  "Free Shipping on Orders Over ₹999",
  "Use code FIRST10 for 10% off your first order",
  "7-day hassle-free returns, always",
];

export default function AnnouncementBar() {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % MESSAGES.length), 4000);
    return () => clearInterval(t);
  }, []);

  return (
    <div
      data-testid="announcement-bar"
      className="relative z-50 flex h-9 items-center justify-center overflow-hidden bg-neutral-900 px-4 text-neutral-100"
    >
      <AnimatePresence mode="wait">
        <motion.p
          key={idx}
          initial={{ y: 12, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -12, opacity: 0 }}
          transition={{ duration: 0.35, ease: "easeOut" }}
          className="text-xs font-medium tracking-[0.08em]"
        >
          {MESSAGES[idx]}
        </motion.p>
      </AnimatePresence>
    </div>
  );
}
